export interface CatalogStatusChip {
  label: string;
  color: 'success' | 'warning' | 'danger' | 'default';
}

/**
 * Stock vocabulary shared by the browse row and the detail modal, keyed by the
 * LOX `VendorItemUnit.stockStatus` value.
 */
export const stockStatusChip: Record<string, CatalogStatusChip> = {
  InStock: { label: 'In stock', color: 'success' },
  OutOfStock: { label: 'Out of stock', color: 'warning' },
  Discontinued: { label: 'Discontinued', color: 'danger' },
};

const NOT_ORDERABLE: CatalogStatusChip = {
  label: 'Not orderable',
  color: 'default',
};

/**
 * The browse row's single Status chip.
 *
 * `isEnabled` is `isOrdering` — a vendor-facing "this unit is purchasable
 * rather than a base-unit reference" flag — and takes precedence, because the
 * stock of a unit buyers cannot order is moot. Everything below it is stock.
 *
 * Deliberately never says "Available": that is the buyer-facing concept
 * computed server-side from the chat's catalog, and neither field here carries
 * it. An unknown / unset `stockStatus` falls back to "In stock", matching the
 * server's default for an orderable unit.
 */
export const resolveCatalogStatusChip = (product: {
  isEnabled: boolean;
  stockStatus: string;
}): CatalogStatusChip =>
  product.isEnabled
    ? (stockStatusChip[product.stockStatus] ?? stockStatusChip.InStock)
    : NOT_ORDERABLE;
